import React from 'react';
import { breakpoints, colors } from '../config';

const Label = ({ children, mb = 0, readOnly, as = 'label', ...rest }) => {
  return (
    <label {...rest}>
      {children}

      <style jsx>{`
        label {
          color: ${colors.brown};
          display: block;
          font-size: 14px;
          font-weight: bold;
          margin-bottom: ${mb}px;

          ${readOnly
            ? `
            color: ${colors.textMuted};
          `
            : ''}
        }

        @media screen and (min-width: ${breakpoints.md}) {
          label {
            font-weight: 900;

            ${readOnly
              ? `
              font-weight: bold;
            `
              : ''}
          }
        }
      `}</style>
    </label>
  );
};

export default Label;
